import store from "@/store/index";

// JSプラグイン
import moment from "@/services/moment";

// S3にログを送出する処理
// 何らか調査が必要な場合に使用する(2021.12現在使用なし)
export const debugAPI = async (Category, TargetValue) => {
  var debugParams = {
    app: "emot",
    platform: "Webview",
    category: Category,
    target_value: TargetValue,
    timestamp: moment(new Date()).format(),
  };
  await store.dispatch("common/postLog", {
    apiParams: debugParams,
  });
};
